export function getTransitionClassnames(styles: Record<string, any>) {
    return {
        appear: styles["appear"],
        appearActive: styles["appearActive"],
        appearDone: styles["appearDone"],
        enter: styles["enter"],
        enterActive: styles["enterActive"],
        enterDone: styles["enterDone"],
        exit: styles["exit"],
        exitActive: styles["exitActive"],
        exitDone: styles["exitDone"],
    }
}
